module.exports = __webpack_public_path__ + "img/back.ee3f5a17.png";